export const ROAMING_SETTINGS_CHANGED_STORAGE_KEY =
  'loxo-outlook-roaming-settings-changed';

export const notifyRoamingSettingsChanged = (): void => {
  if (typeof localStorage === 'undefined') {
    return;
  }

  localStorage.setItem(
    ROAMING_SETTINGS_CHANGED_STORAGE_KEY,
    `${Date.now()}:${Math.random()}`
  );
};

const readRoamingSettingsChangedValue = (): string | null => {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  return localStorage.getItem(ROAMING_SETTINGS_CHANGED_STORAGE_KEY);
};

export const subscribeToRoamingSettingsChanges = (
  onChanged: () => void
): (() => void) => {
  let lastSeenChange = readRoamingSettingsChangedValue();

  const notifyIfChanged = (value: string | null) => {
    if (value == null || value === lastSeenChange) {
      return;
    }

    lastSeenChange = value;
    onChanged();
  };

  const onStorage = (event: StorageEvent) => {
    if (event.key === ROAMING_SETTINGS_CHANGED_STORAGE_KEY) {
      notifyIfChanged(event.newValue);
    }
  };

  const onFocus = () => notifyIfChanged(readRoamingSettingsChangedValue());

  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      notifyIfChanged(readRoamingSettingsChangedValue());
    }
  };

  window.addEventListener('storage', onStorage);
  window.addEventListener('focus', onFocus);
  document.addEventListener('visibilitychange', onVisibilityChange);

  return () => {
    window.removeEventListener('storage', onStorage);
    window.removeEventListener('focus', onFocus);
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
};
